import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { redIcon } from "../../../helpers/mapIcons";
import { calculateMapCenter } from "../../../services/mapService";

const ProvidersMap = ({ providers }) => {
  const center = calculateMapCenter(providers);

  return (
    <MapContainer
      center={center}
      zoom={5}
      style={{ height: "220px", width: "100%", borderRadius: "20px" }}
      zoomControl={false}
      dragging={false}
      touchZoom={false}
      scrollWheelZoom={false}
      doubleClickZoom={false}
      attributionControl={false}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {providers.map((provider) => (
        <Marker
          key={provider.providerId}
          position={[provider.latitude, provider.longitude]}
          icon={redIcon}
        >
          <Popup>
            <strong>
              Dr.{provider.doctor.firstName} {provider.doctor.lastName}
            </strong>
            <br />
            {provider.city}, {provider.state}
            <br />
            {/* {provider.address} */}
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default ProvidersMap;
